/**
 * D24DivisionsTable Component
 * Container for two D24 systems:
 * 1. Atri Muni Relatives (24 Horas)
 * 2. Guna Tattva (24 Gunas)
 */

import React from 'react';
import { JatakaResponse } from '../../../../../models/api';
import { ExpandableSectionsContainer, ExpandableSection } from './ExpandableSectionsContainer';
import { AtriRelativesInfoTable } from './AtriRelativesInfoTable';
import { GunaTattvaInfoTable } from './GunaTattvaInfoTable';

export interface D24DivisionsTableProps {
  apiResponse?: JatakaResponse | null;
}

export const D24DivisionsTable: React.FC<D24DivisionsTableProps> = ({ apiResponse }) => {
  const sections: ExpandableSection[] = [
    {
      storageKey: 'd24-atri-expanded',
      label: 'Atri Muni Relatives',
      component: <AtriRelativesInfoTable apiResponse={apiResponse} />,
    },
    {
      storageKey: 'd24-guna-expanded',
      label: 'Guna Tattva',
      component: <GunaTattvaInfoTable apiResponse={apiResponse} />,
    },
  ];

  return <ExpandableSectionsContainer sections={sections} />;
};
